import React from 'react';

const Header = () => {
  return (
    <div className="mb-2 mt-4">
      <h1 className="fs-2">Know-How</h1>
      <p className="mb-0 text-muted mt-1">
        Access a wealth of tutorials, FAQs, and expert advice to help you make the
        most of Printcart&apos;s features. Stay informed and improve your skills with our
        extensive knowledge base.
      </p>
    </div>
  );
};
export default Header;
